<script setup lang="ts">
import { NovaBoxAuctionCard } from '#components'

const auctionStore = useAuctionStore()
const { auctions } = storeToRefs(auctionStore)
const isLoading = ref(false)
const isError = ref(false)
const auctionAreaRef = ref<Element>()
const auctionCardsRef = ref<(typeof NovaBoxAuctionCard)[]>([])

onMounted(async () => {
  await fetchAuctions()
})

const fetchAuctions = async () => {
  try {
    isLoading.value = true
    isError.value = false
    await auctionStore.fetchAuctions()
  } catch {
    isError.value = true
  } finally {
    isLoading.value = false
  }
}
</script>

<template>
  <div ref="auctionAreaRef" class="list-area">
    <ClientOnly>
      <div class="auctions">
        <NovaLoadingIndicator
          v-if="isLoading"
          :bg-bright="'light'"
          :fill="true"
        />

        <NovaBoxEmptyMessage
          v-if="!isLoading && isError"
          :message="$t('auction.auctionError')"
          :fill="true"
        />

        <NovaBoxEmptyMessage
          v-if="!isLoading && !isError && !auctions.length"
          :message="$t('auction.auctionEmpty')"
          :fill="true"
        />

        <NovaRecyclerGrid
          v-if="!isLoading && !isError && auctions.length"
          :items="auctions"
          :is-last="true"
          :is-loading="isLoading"
          :is-error="isError"
          :is-refresh="true"
          :key-name="'spcaucNttSn'"
          :size-dependencies="[]"
          :page-mode="true"
          :error-message="$t('statusMessages.mypageList.post.error')"
          :responsive="{
            mobile: { columns: 2, rowGap: 12, columnGap: 12 },
            tablet: { columns: 4, rowGap: 12, columnGap: 12 },
            desktop: { columns: 5, rowGap: 12, columnGap: 12 },
          }"
          :buffer="600"
        >
          <template #item="{ item, index }">
            <NovaBoxAuctionCard
              :ref="
                (el: typeof NovaBoxAuctionCard) => {
                  auctionCardsRef[index] = el
                }
              "
              :source="item"
            />
          </template>
        </NovaRecyclerGrid>
      </div>
    </ClientOnly>
  </div>
</template>

<style lang="scss" scoped>
.list-area {
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  .top-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 12px;

    .title {
      @include text-style($text-heading3-medium);

      @include mobile {
        @include text-style($text-body-14-bold);
      }
    }

    .search-input {
      width: 300px;

      .search-button {
        color: $color-text-4;
      }
    }
  }

  .auctions {
    display: flex;
    flex-direction: column;

    > .list {
      padding-top: 20px;

      :deep(.vue-recycle-scroller) {
        width: 100%;
        margin-left: -12px;
      }

      :deep(.vue-recycle-scroller__item-view) {
        padding: 12px;
      }

      //display: grid;
      //grid-template-columns: repeat(6, minmax(0, 1fr));
      //-webkit-grid-template-columns: repeat(5, minmax(0, 1fr));
      //column-gap: 24px;
      //row-gap: 24px;
      //padding-top: 20px;
      //
      //@include tablet {
      //  grid-template-columns: repeat(4, minmax(0, 1fr));
      //  -webkit-grid-template-columns: repeat(4, minmax(0, 1fr));
      //  column-gap: 15px;
      //}
      //
      //@include mobile {
      //  grid-template-columns: repeat(2, minmax(0, 1fr));
      //  -webkit-grid-template-columns: repeat(3, minmax(0, 1fr));
      //}
    }
  }
}
</style>
